export default "__VITE_ASSET__B9tRZtN0__"